import { Button, Icon } from "@plum-xoxo/admin-dsm";
import React from "react";
import theme from "../../../theme";
import Loader from "../../Loader";

const TemplatePreview = ({ loader, imgSrc, toggleModalState }) => {
  return (
    <>
      {imgSrc ? (
        <div className="px-10">
          {loader ? <div className="w-100" style={{
            minHeight: 200
          }}>
            <Loader />
          </div> : <img className="w-100" src={imgSrc} />}
        </div>
      ) : (
          <div className="px-10">
            <div style={{
              border: `1px dashed ${theme.palette.light.c300}`
            }} className="text-center cursor-pointer" onClick={toggleModalState}>
              <Button
                variant="plain"
                color="primary"
                startIcon={<Icon iconName="Plus" size={18} color="primary" shade="c02" />}
                className="my-10"
              >
                Add Banner
              </Button>
            </div>
          </div>
      )}
    </>
  );
};

export default TemplatePreview;
